import * as yup from "yup";

export const MaterialItemSchema = yup.object().shape({
  itemName: yup.string(),
  quantity: yup
    .number()

    .nullable(), // If this is optional
  materialType: yup.string().nullable(), // You can add a validation if units are specific
  quantityUnit: yup.string().nullable(), // You can add a validation if units are specific
  weight: yup.number().nullable(),
  weightUnit: yup.string().nullable(), // Validation for unit could be added if needed
  rate: yup.number().nullable(),
  diameterInMM: yup.string().nullable(),
  lengthInMeters: yup.string().nullable(),
});

export const MaterialForBaySpanSchema = yup.object().shape({
  bay: yup.number().required("Required"),
  span: yup.number().required("Required"),
  systemType: yup.string().required("Required"),
});

export const MaterialPlanningSchema = yup.object().shape({
  foundation: yup.object().shape(MaterialItemSchema.fields),

  arc: yup.object().shape(MaterialItemSchema.fields),

  smallColumn: yup.object().shape(MaterialItemSchema.fields),

  bigColumn: yup.object().shape(MaterialItemSchema.fields),

  member: yup.object().shape(MaterialItemSchema.fields),

  bottom: yup.object().shape(MaterialItemSchema.fields),

  purline: yup.object().shape(MaterialItemSchema.fields),

  topPurline: yup.object().shape(MaterialItemSchema.fields),

  hockey: yup.object().shape(MaterialItemSchema.fields),

  hockeyMember: yup.object().shape(MaterialItemSchema.fields),

  endPurline: yup.object().shape(MaterialItemSchema.fields),

  curtainHandle: yup.object().shape(MaterialItemSchema.fields),

  flapControl: yup.object().shape(MaterialItemSchema.fields),

  exaustFan: yup.object().shape(MaterialItemSchema.fields),

  coolingPad: yup.object().shape(MaterialItemSchema.fields),

  tFixture: yup.object().shape(MaterialItemSchema.fields),

  profile: yup.object().shape(MaterialItemSchema.fields),

  door: yup.object().shape(MaterialItemSchema.fields),

  doorHinges: yup.object().shape(MaterialItemSchema.fields),

  selfScrew: yup.object().shape(MaterialItemSchema.fields),

  studPipe: yup.object().shape(MaterialItemSchema.fields),

  holFast: yup.object().shape(MaterialItemSchema.fields),

  spring: yup.object().shape(MaterialItemSchema.fields),

  giTar12: yup.object().shape(MaterialItemSchema.fields),

  curtainHandleLock: yup.object().shape(MaterialItemSchema.fields),

  crossBar: yup.object().shape(MaterialItemSchema.fields),

  doorSupportRod: yup.object().shape(MaterialItemSchema.fields),

  curtainClamp: yup.object().shape(MaterialItemSchema.fields),

  fullClamp60: yup.object().shape(MaterialItemSchema.fields),

  fullClamp48: yup.object().shape(MaterialItemSchema.fields),

  fullClamp42: yup.object().shape(MaterialItemSchema.fields),

  halfClamp60: yup.object().shape(MaterialItemSchema.fields),

  halfClamp42: yup.object().shape(MaterialItemSchema.fields),

  s10By150: yup.object().shape(MaterialItemSchema.fields),

  s10By80: yup.object().shape(MaterialItemSchema.fields),

  s10By60: yup.object().shape(MaterialItemSchema.fields),

  s10By40: yup.object().shape(MaterialItemSchema.fields),

  bolt10: yup.object().shape(MaterialItemSchema.fields),

  mainColumn: yup.object().shape(MaterialItemSchema.fields),

  bracingRod: yup.object().shape(MaterialItemSchema.fields),

  doorHandle: yup.object().shape(MaterialItemSchema.fields),

  bigBottom: yup.object().shape(MaterialItemSchema.fields),

  smallBottom: yup.object().shape(MaterialItemSchema.fields),

  bigArc: yup.object().shape(MaterialItemSchema.fields),

  smallArc: yup.object().shape(MaterialItemSchema.fields),

  endArc: yup.object().shape(MaterialItemSchema.fields),

  secondPurline: yup.object().shape(MaterialItemSchema.fields),

  gutterPurline4m: yup.object().shape(MaterialItemSchema.fields),

  gutterPurline6m: yup.object().shape(MaterialItemSchema.fields),

  hockeyRunner: yup.object().shape(MaterialItemSchema.fields),

  tieBar: yup.object().shape(MaterialItemSchema.fields),

  wBig: yup.object().shape(MaterialItemSchema.fields),

  wMedium: yup.object().shape(MaterialItemSchema.fields),

  wSmall: yup.object().shape(MaterialItemSchema.fields),

  vent: yup.object().shape(MaterialItemSchema.fields),

  handles: yup.object().shape(MaterialItemSchema.fields),

  fBracket: yup.object().shape(MaterialItemSchema.fields),

  lPipe: yup.object().shape(MaterialItemSchema.fields),

  tPipe: yup.object().shape(MaterialItemSchema.fields),

  lBracket: yup.object().shape(MaterialItemSchema.fields),

  handleLock: yup.object().shape(MaterialItemSchema.fields),

  selfTappingScrew: yup.object().shape(MaterialItemSchema.fields),

  shadenetPulley: yup.object().shape(MaterialItemSchema.fields),

  springTar: yup.object().shape(MaterialItemSchema.fields),

  giTar14: yup.object().shape(MaterialItemSchema.fields),

  ropes: yup.object().shape(MaterialItemSchema.fields),

  ring: yup.object().shape(MaterialItemSchema.fields),

  doorSection: yup.object().shape(MaterialItemSchema.fields),

  rollerBox: yup.object().shape(MaterialItemSchema.fields),

  fullClamp76: yup.object().shape(MaterialItemSchema.fields),

  halfClamp76: yup.object().shape(MaterialItemSchema.fields),

  s10By100: yup.object().shape(MaterialItemSchema.fields),

  s8By100: yup.object().shape(MaterialItemSchema.fields),

  s6By60: yup.object().shape(MaterialItemSchema.fields),

  bolt6: yup.object().shape(MaterialItemSchema.fields),

  bolt8: yup.object().shape(MaterialItemSchema.fields),

  columnMember: yup.object().shape(MaterialItemSchema.fields),

  s6By100: yup.object().shape(MaterialItemSchema.fields),

  smallMember33: yup.object().shape(MaterialItemSchema.fields),

  way3: yup.object().shape(MaterialItemSchema.fields),

  way4: yup.object().shape(MaterialItemSchema.fields),

  way5: yup.object().shape(MaterialItemSchema.fields),
});
